import Vue from 'vue';
import Vuex from 'vuex';

import user from '@/store/modules/user';
import skillenable from '@/store/modules/skillenable';

Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
        user,
        skillenable
    },
    // **不要在发布环境下启用严格模式，会造成性能损失！**
    strict: process.env.NODE_ENV !== 'production'
})


//////////////////
// WEBPACK FOOTER
// ./src/store/index.js
// module id = null
// module chunks = 